module.exports = __webpack_public_path__ + "media/bgm_box.27901971.mp3";